<template>
  <div class="trial-lockout-overlay" :style="overlayStyle">
    <div class="trial-lockout-modal" role="dialog" aria-labelledby="past-due-lockout-title">
      <div class="trial-lockout-icon" aria-hidden="true">
        <svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <h2 id="past-due-lockout-title" class="trial-lockout-title">{{ copy.title }}</h2>
      <p class="trial-lockout-sub" v-html="copy.messageHtml"></p>

      <button type="button" class="trial-lockout-primary" @click="goUpdatePayment">
        Update payment method →
      </button>

      <p class="trial-lockout-foot">
        <a href="mailto:support@sentrykit.com?subject=SentryKit%20payment%20failed">Contact support</a>
        ·
        <button type="button" @click="signOut">Log out</button>
      </p>
    </div>
  </div>
</template>

<script>
import './styles/TrialLockout.css'
import { pastDueLockoutCopyFromSummary } from '../../utils/subscriptionBilling'
import { requestOpenBillingPaymentModal } from '../../utils/billingUpgrade'

export default {
  name: 'PastDueLockoutOverlay',
  props: {
    stripOffsetPx: {
      type: Number,
      default: 0
    }
  },
  computed: {
    overlayStyle: function () {
      return { top: this.stripOffsetPx + 'px' }
    },
    copy: function () {
      return pastDueLockoutCopyFromSummary(this.$root.subscriptionSummary)
    }
  },
  methods: {
    goUpdatePayment: function () {
      requestOpenBillingPaymentModal(this)
    },
    signOut: function () {
      if (this.$root.signOutUser) {
        this.$root.signOutUser()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PastDueLockoutOverlay.vue?11bbc1e2